import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import '../assets/styles/members.css';
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import axios from "axios";
import config from '../config.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";

function Addmembers({ closePopup }) {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Personal");
  const [formData, setFormData] = useState({ Name: "", phone: "", email: "", country: "", state: "", city: "", postCode: "", companyName: "", businessType: "", industry: "", });
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        toast.error("File size should not exceed 10MB.");
        return;
      }
      if (!["application/pdf", "image/jpeg", "image/png"].includes(file.type)) {
        toast.error("Invalid file type. Please upload PDF, JPG, or PNG.");
        return;
      }
      setUploadedFile(file);
    }
  };
  

  const handleRemoveFile = () => {
    setUploadedFile(null);
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setFormData({ Name: "", phone: "", email: "", country: "", state: "", city: "", postCode: "", companyName: "", businessType: "", industry: "", });
    setUploadedFile(null);
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const countriesResponse = await axios.get(`${config.apiBaseUrl}/admin/countries`);
        setCountries(countriesResponse.data);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };

    fetchData();
  }, []);

  const handleCountryChange = async (e) => {
    const selectedCountry = e.target.value;
    const selectedCountryObj = countries.find(country => country.name === selectedCountry);
    if (selectedCountryObj) {
      const countryId = selectedCountryObj.id;
      setFormData(prevState => ({ ...prevState, country: selectedCountry, state: "", city: "" }));
      try {
        const statesResponse = await axios.get(`${config.apiBaseUrl}/admin/states?country_id=${countryId}`);
        setStates(statesResponse.data);
      } catch (error) {
        console.error('Error fetching states:', error);
      }
    }
  };


  const handleStateChange = async (e) => {
    const selectedStateid = e.target.value;
    const selectedState = states.find(state => state.id === parseInt(selectedStateid));
    setFormData(prevState => ({ ...prevState, state: selectedState.name , city: "" }));

    try {
      const citiesResponse = await axios.get(`${config.apiBaseUrl}/admin/citys?state_id=${selectedStateid}`);
      setCities(citiesResponse.data);
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  const uploadMembersImageINS3 = async (imageFile) => {
    try {
      const s3Client = new S3Client({
        region: "ap-south-1",
        credentials: {
          accessKeyId: "AKIAVIOZF2XRHGYOT3GT",
          secretAccessKey: "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",
        },
      });

      const bucketName = "neurolinkai";
      const key = `nl_client_doc/${imageFile.name}`;
      const mimeType = imageFile.type || "image/jpeg";

      const command = new PutObjectCommand({
        Bucket: bucketName,
        Key: key,
        ContentType: mimeType,
        Body: imageFile,
        ACL: "public-read",
      });

      const signedUrl = await getSignedUrl(s3Client, command, { expiresIn: 3600 });
      const uploadResponse = await axios.put(signedUrl, imageFile, {
        headers: {
          "Content-Type": mimeType,
        },
      });

      if (uploadResponse.status === 200) {
        const imageUrlS3 = `https://${bucketName}.s3.ap-south-1.amazonaws.com/${key}`;
        console.log("Image successfully uploaded to S3:", imageUrlS3);
        return imageUrlS3;
      } else {
        throw new Error(`Failed to upload image to S3: ${uploadResponse.status}`);
      }
    } catch (error) {
      console.error("Failed to upload image:", error);
      throw error;
    }
  };


  const handleSave = async () => {
    if (!formData.Name || !formData.phone || !formData.email || !formData.country || !formData.state || !formData.city || !formData.postCode) {
      toast.error("Please fill in all required fields.");
      return;
    }
    if (!/^\d{10}$/.test(formData.phone.trim())) {
      toast.error("Please enter a valid 10-digit phone number.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      toast.error("Please enter a valid email address.");
      return;
    }
    if (!uploadedFile) {
      toast.error("Please upload your ID proof.");
      return;
    }
    try {
      setLoading(true);
      let s3Url = "";
      if (uploadedFile) {
        s3Url = await uploadMembersImageINS3(uploadedFile);
      }
      const payload = {
        name: formData.Name.trim(),
        email: formData.email.trim().toLowerCase(),
        phone_number: formData.phone.trim(),
        country: formData.country,
        state: formData.state,
        city: formData.city,
        pincode: formData.postCode,
        company_name: formData.companyName,
        business_type: formData.businessType,
        industry: formData.industry,
        doc_proof: s3Url,
        created_by: 1,
        client_type: selectedOption === "Personal" ? "Personal" : "Business",
      };
  
      const response = await fetch(`${config.apiBaseUrl}/admin/createclient`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
  
      if (response.ok) {
        const { message } = await response.json();
        toast.success(message);
        setFormData({
          Name: "",
          phone: "",
          email: "",
          country: "",
          state: "",
          city: "",
          postCode: "",
          companyName: "",
          businessType: "",
          industry: "",
        });
        setUploadedFile(null);
      } else if (response.status === 409) {
        const errorData = await response.json();
        if (errorData.error.includes("Email")) {
          toast.error("This email is already registered.");
        } else if (errorData.error.includes("Phone")) {
          toast.error("This phone number is already registered.");
        }
      } else {
        toast.error("Failed to add member. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred: " + error.message);
      console.error("Error in handleSave:", error);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="member-cm">
      <ToastContainer />
      <div className="overview-members">
        <h4 className="membertxt">Add member</h4>
        <div className="ms-5">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              id="inlineRadio1"
              value="Personal"
              checked={selectedOption === "Personal"}
              onChange={handleOptionChange}
            />
            <label className="form-check-label" htmlFor="inlineRadio1">
              Personal
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              id="inlineRadio2"
              value="Business"
              checked={selectedOption === "Business"}
              onChange={handleOptionChange}
            />
            <label className="form-check-label" htmlFor="inlineRadio2">
              Business
            </label>
          </div>
        </div>
        {selectedOption === "Personal" && (
          <div className="row">
            <div className="col-lg-2 col-md-1 col-sm-0 col-0"></div>
            <div className="col-lg-8 col-10 cols-12 col-12">
              <h6 className="mt-3">Please enter all the below information.</h6>
              <div className="row">
                <div className='col-lg-12 col-md-12 col-sm-12 col-12 mt-4 '>
                  <input type="text" className="input-forms" placeholder="Name" required name="Name" value={formData.Name} onChange={handleInputChange} />
                </div>
                <div className='col-lg-12 col-md-12 col-sm-12 col-12 mt-4'>
                  <input type='text' className='input-forms' placeholder='Phone' required name="phone" value={formData.phone} onChange={handleInputChange} />
                </div>
                <div className='col-lg-12 col-md-12 col-sm-12 col-12 mt-4'>
                  <input type='email' className='input-forms' placeholder='E-mail' required name="email" value={formData.email} onChange={handleInputChange} />
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 mt-4'>
                  <select className='input-forms' name="country" value={formData.country} onChange={handleCountryChange} required>
                    <option value="">Choose country</option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.name}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className='col-lg-6 col-md-6 col-sm-12 col-12 mt-4'>
                  <select className='input-forms' name="state" onChange={handleStateChange} required>
                    <option value="">Choose State</option>
                    {states.map(state => (
                      <option key={state.id} value={state.id}>{state.name}</option>
                    ))}
                  </select>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 mt-4'>
                  <select className='input-forms' name="city" value={formData.city} onChange={handleInputChange} required >
                    <option value="" >  Choose district </option>
                    {cities.map(city => (
                      <option key={city.id} value={city.name}>{city.name}</option>
                    ))}
                  </select>
                </div>
                <div className='col-md-6 col-sm-6 col-12 mt-4'>
                  <input type='text' className='input-forms' placeholder='Post code' name="postCode" required value={formData.postCode}
                    onChange={handleInputChange} />
                </div>
                <div className="col-md-12 col-sm-12 col-12 mt-4">
                  <label htmlFor="file-upload" className="file-upload-container">
                    <div className="file-upload-box">
                      <span className="upload-icon">📄</span>
                      <span className="upload-text">
                        Click here to upload your ID proof.
                      </span>
                      <span className="upload-support">
                        Supported Format: PDF, Word, JPG. (10mb each)
                      </span>
                    </div>
                    <input
                      id="file-upload"
                      type="file"
                      className="input-file"
                      required
                      onChange={handleFileUpload}
                    />
                  </label>
                </div>
                {uploadedFile && (
                  <div className="uploaded-file-details mt-4">
                    <p>
                      <strong>File Name:</strong> {uploadedFile.name}
                      <span className="removefileicon"><FontAwesomeIcon icon={faX} onClick={handleRemoveFile} /></span>
                    </p>

                  </div>
                )}
                <div className="col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-3">
                  <button className="Addmember-btn mt-2" onClick={handleSave}>Save</button>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-1 col-sm-0 col-0"></div>
          </div>
        )}
        {selectedOption === "Business" && (
          <div className='row  '>
            <div className='col-lg-2 col-md-1 col-sm-0 col-0'></div>
            <div className='col-lg-8 col-10 cols-12 col-12  '>
              <h6 className='mt-3'>Please enter all the below information.</h6>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 mt-4 '>
                  <input type="text" className="input-forms" placeholder="Name" required name="Name" value={formData.Name} onChange={handleInputChange} />
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 mt-4'>
                  <input type='text' className='input-forms' placeholder='Phone' required name="phone" value={formData.phone}
                    onChange={handleInputChange} />
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 mt-4'>
                  <input type='email' className='input-forms' placeholder='E-mail' required name="email" value={formData.email}
                    onChange={handleInputChange} />
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 mt-4'>
                <select className='input-forms' name="country" value={formData.country} onChange={handleCountryChange} required>
                    <option value="">Choose country</option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.name}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                  </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 mt-4'>
                  <select className='input-forms' name="state" onChange={handleStateChange} required>
                    <option value="">Choose State</option>
                    {states.map(state => (
                      <option key={state.id} value={state.id}>{state.name}</option>
                    ))}
                  </select>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 mt-4'>
                  <select className='input-forms' name="city" value={formData.city} onChange={handleInputChange} required >
                    <option value="" >  Choose district </option>
                    {cities.map(city => (
                      <option key={city.id} value={city.name}>{city.name}</option>
                    ))}
                  </select>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 mt-4'>
                  <input type='text' className='input-forms' placeholder='Post code ' required name="postCode" value={formData.postCode}
                    onChange={handleInputChange} />
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 mt-4'>
                  <input type='text' className='input-forms' placeholder='Company name ' required name="companyName" value={formData.companyName}
                    onChange={handleInputChange} />
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 mt-4'>
                  <input type='text' className='input-forms' placeholder='Business type ' required name="businessType" value={formData.businessType}
                    onChange={handleInputChange} />
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-12 mt-4'>
                  <input type='text' className='input-forms' placeholder='Industry' required name="industry" value={formData.industry}
                    onChange={handleInputChange} />
                </div>
                <div className="col-md-12 col-sm-12 col-12 mt-4">
                  <label htmlFor="file-upload" className="file-upload-container">
                    <div className="file-upload-box">
                      <span className="upload-icon">📄</span>
                      <span className="upload-text">Click here to upload your business document.</span>
                      <span className="upload-support">
                        Supported Format: PDF, Word, JPG. (10mb each)
                      </span>
                    </div>
                    <input id="file-upload"
                      type="file"
                      className="input-file"
                      required
                      onChange={handleFileUpload} />
                  </label>
                </div>
                <div>
                  {uploadedFile && (
                    <div className="uploaded-file-details mt-4">
                      <p>
                        <strong>File Name:</strong> {uploadedFile.name}
                        <span className="removefileicon"><FontAwesomeIcon icon={faX} onClick={handleRemoveFile} /></span>
                      </p>
                    </div>
                  )}
                </div>
                <div className="col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-3">
                  <button
                    className="Addmember-btn mt-2"
                    onClick={handleSave}
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
            <div className='col-lg-2 col-md-1 col-sm-0 col-0'></div>
          </div>
        )}
      </div>
      <div className="col-md-12 col-sm-12 col-12 mt-5 d-flex justify-content-end">
        <button className="btn btn-danger  mt-2 ms-5 btn-danger" onClick={closePopup}>
          close
        </button>
      </div>
    </div>
  );
}

export default Addmembers;
